import { render, staticRenderFns } from "./alterPassword.vue?vue&type=template&id=362efd5f&scoped=true"
import script from "./alterPassword.vue?vue&type=script&lang=js"
export * from "./alterPassword.vue?vue&type=script&lang=js"
import style0 from "./alterPassword.vue?vue&type=style&index=0&id=362efd5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362efd5f",
  null
  
)

export default component.exports